const removeHtmlTags = (str) => {
  if (typeof str !== 'string') {
    throw new TypeError('Input to removeHtmlTags must be a string');
  }
  return str.split(/<[^>]*>/).join('');
};

export default removeHtmlTags;
